import dynamic from 'next/dynamic';

import { AlertProps } from './HotelAlerts.types';

export const HotelAlertsMGP = dynamic<AlertProps>(() => import('./HotelAlerts').then(module => module.HotelAlerts));
